"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVERYONE = {
    _class: ['UserGroup', 'Everyone'],
    _type: 'everyone',
    _key: 'global:everyone',
    principal: '*',
    public: true,
    displayName: 'Everyone (Public Global)',
};
exports.INTERNET = {
    _class: ['Internet', 'Network'],
    _type: 'internet',
    _key: 'global:internet',
    CIDR: '0.0.0.0/0',
    CIDRv6: '::/0',
    public: true,
    displayName: 'Internet',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2xvYmFsRW50aXRpZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZ2xvYmFsRW50aXRpZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBYSxRQUFBLFFBQVEsR0FBRztJQUN0QixNQUFNLEVBQUUsQ0FBQyxXQUFXLEVBQUUsVUFBVSxDQUFDO0lBQ2pDLEtBQUssRUFBRSxVQUFVO0lBQ2pCLElBQUksRUFBRSxpQkFBaUI7SUFDdkIsU0FBUyxFQUFFLEdBQUc7SUFDZCxNQUFNLEVBQUUsSUFBSTtJQUNaLFdBQVcsRUFBRSwwQkFBMEI7Q0FDeEMsQ0FBQztBQUVXLFFBQUEsUUFBUSxHQUFHO0lBQ3RCLE1BQU0sRUFBRSxDQUFDLFVBQVUsRUFBRSxTQUFTLENBQUM7SUFDL0IsS0FBSyxFQUFFLFVBQVU7SUFDakIsSUFBSSxFQUFFLGlCQUFpQjtJQUN2QixJQUFJLEVBQUUsV0FBVztJQUNqQixNQUFNLEVBQUUsTUFBTTtJQUNkLE1BQU0sRUFBRSxJQUFJO0lBQ1osV0FBVyxFQUFFLFVBQVU7Q0FDeEIsQ0FBQyJ9